export const industries = [
    "Alcoholic Beverages",
    "Apparel",
    "Automotive Accessories",
    "Baby Products",
    "Bags and Luggage",
    "Beauty and Personal Care",
    "Beverages",
    "Books and Magazines",
    "Camping and Outdoor Gear",
    "Cleaning Supplies",
    "Computers and Accessories",
    "Consumer Electronics",
    "Dairy Products",
    "Digital Services",
    "DIY and Hardware",
    "Electronics and Gadgets",
    "Eyewear",
    "Fashion and Accessories",
    "Fitness and Exercise Equipment",
    "Flowers and Gifts",
    "Food and Snacks",
    "Footwear",
    "Fragrances",
    "Frozen Foods",
    "Furniture and Home Decor",
    "Gaming Equipment",
    "Garden and Outdoor Living",
    "Gourmet and Specialty Foods",
    "Grocery and Pantry Staples",
    "Haircare Products",
    "Handbags and Wallets",
    "Health and Wellness",
    "Home Appliances",
    "Home Improvement",
    "Jewellery and Watches",
    "Kitchenware and Cookware",
    "Lighting and Fixtures",
    "Meat and Seafood",
    "Medical and Healthcare Products",
    "Menswear",
    "Music",
    "Musical Instruments",
    "Office Supplies",
    "Organic and Natural Products",
    "Packaged Foods",
    "Party Supplies",
    "Pet Food and Supplies",
    "Pharmaceuticals and Supplements",
    "Photography and Videography",
    "Phones and Smart Devices",
    "Skincare",
    "Software and Apps",
    "Sports Equipment",
    "Stationery and Office Supplies",
    "Streaming and Digital Content",
    "Sunglasses and Optical Wear",
    "Sustainable and Eco-Friendly Products",
    "Tableware and Dining",
    "Toys and Games",
    "Travel and Luggage",
    "Vegan and Plant-Based Products",
    "Watches and Accessories",
    "Womenswear",
];
